import React from 'react';
import { Link } from 'react-router-dom';
import './About.css'; // Import the CSS file
import image from "../../images/AxiomosLogo.png";

function About() {
  return (
    <div className="about-container">
      <div className='about-contain'>
        <h1 className="about-title">About Us As A Custom Software Development & Digital Transformation Company</h1>
        <p className="about-title2">Axiomos was founded with a mission to revolutionize technology solutions across industries, including civil, mechanical, and management sectors.</p>
        <p className='about-description'>
          At Axiomos, we specialize in crafting tailored software solutions that drive efficiency and innovation. From civil engineering applications to mechanical automation and management systems, we integrate cutting-edge technology to enhance operational performance. Our commitment to ethical software development ensures sustainable growth for businesses, empowering them with scalable and reliable digital solutions.
        </p>
        <Link to="/about" className='btn-about'>LEARN ABOUT US</Link>
      </div>
      <div className='about-image'>
        <img src={image} className='about-img' alt="Axiomos Logo" />
      </div>
    </div>
  );
}

export default About;
